export default "__VITE_ASSET__f4b88db4__"